export const SS_COMMENT_ALL_SECTION_KEY = 'all';
export const SS_COMMENT_SECTION_URL_PARAM = 'commentSectionId';
export const SS_NOTIFICATION_SECTION_URL_PARAM = 'notificationId';
